module.exports = __webpack_public_path__ + "img/city2.b48f8f6f.png";